// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flow-panel--body .query-builder{border:2px solid #07070e;background-color:#07070e;border-radius:2px;padding:2px;position:relative;height:100%;width:100%}", ""]);
// Exports
module.exports = exports;
